// Transform list data from GraphQl to UI state format for each list type
export const transformListToState = (type, list) => {
    if (list) {
        const filteredList = list.filter((item) => item.type === type);
        let id = 1;
        const processedList = filteredList.map((item) => {
            let entries;
            if (type !== "MeetingSubject") {
                if (!item.entries) {
                    entries = "";
                } else {
                    const idArray = (item.entries === "undefined" || item.entries == null || item.entries == "")
                        ? []
                        : item.entries.split(",").filter(entry => entry !== "");
                    const listPersons = [];
                    for (let x = 0; x < idArray.length; x++) {
                        listPersons.push({
                            userId: idArray[x],
                            key: idArray[x],
                        });
                    }
                    entries = listPersons;
                }
            } else {
                entries = item.entries;
            }
            return {
                id: id++,
                data: {
                    entries,
                    matchMode: item.matchMode,
                    isActive: item.isActive
                },
            };
        });
        return processedList.length > 0 ? processedList : [{ id: 1, data: { entries: "", matchMode: "Match", isActive: false } }];
    } else {
        return [{ id: 1, data: { entries: "", matchMode: "Match", isActive: false } }];
    }
};
// -----------------------------------------------------------------------------------------------------------------------------------------------
export const transformStateToList = (participants, callQueue, meetingOrganizers, meetingAttendees, meetingSubject) => {
    const list = [];
    if (participants) {
        participants.forEach((item) => {
            const entries = Array.isArray(item.data.entries)
                ? item.data.entries.map((entry) => entry.key).join(",")
                : "";
            list.push({
                type: "Participants",
                entries,
                matchMode: item.data.matchMode,
                isActive: item.data.isActive,
            });
        });
    }
    if (callQueue) {
        callQueue.forEach((item) => {
            const entries = Array.isArray(item.data.entries)
                ? item.data.entries.map((entry) => entry.key).join(",")
                : "";
            list.push({
                type: "CallQueue",
                entries,
                matchMode: item.data.matchMode,
                isActive: item.data.isActive,

            });
        });
    }
    if (meetingOrganizers) {
        meetingOrganizers.forEach((item) => {
            const entries = Array.isArray(item.data.entries)
                ? item.data.entries.map((entry) => entry.key).join(",")
                : "";
            list.push({
                type: "Organizers",
                entries,
                matchMode: item.data.matchMode,
                isActive: item.data.isActive,

            });
        });
    }
    if (meetingAttendees) {
        meetingAttendees.forEach((item) => {
            const entries = Array.isArray(item.data.entries)
                ? item.data.entries.map((entry) => entry.key).join(",")
                : "";
            list.push({
                type: "Attendees",
                entries,
                matchMode: item.data.matchMode,
                isActive: item.data.isActive,

            });
        });
    }
    if (meetingSubject) {
        meetingSubject.forEach((item) => {
            list.push({
                type: "MeetingSubject",
                entries: item.data.entries,
                matchMode: item.data.matchMode,
                isActive: item.data.isActive,

            });
        });
    }
    return list;
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

// Transform timetable data from GraphQl to UI state format
export const transformTimetableToState = (timetable) => {
    const schedule = [];
    let idCounter = 0;

    // Process daily schedules
    if (timetable.daily) {
        timetable.daily.forEach((item) => {
            schedule.push({
                id: idCounter++,
                data: {
                    period: "daily",
                    globalStartTime: item.start,
                    globalEndTime: item.stop,
                    interval: null,
                    week: {
                        monday: { isActive: false },
                        tuesday: { isActive: false },
                        wednesday: { isActive: false },
                        thursday: { isActive: false },
                        friday: { isActive: false },
                        saturday: { isActive: false },
                        sunday: { isActive: false },
                    },
                },
            });
        });
    }

    // Process weekly schedules
    if (timetable.weekly) {
        timetable.weekly.forEach((item) => {
            const week = {
                monday: { isActive: false },
                tuesday: { isActive: false },
                wednesday: { isActive: false },
                thursday: { isActive: false },
                friday: { isActive: false },
                saturday: { isActive: false },
                sunday: { isActive: false },
            };

            item.days.forEach((day) => {
                week[day.toLowerCase()] = {
                    isActive: true,
                };
            });

            schedule.push({
                id: idCounter++,
                data: {
                    period: "weekly",
                    globalStartTime: item.start,
                    globalEndTime: item.stop,
                    interval: null,
                    week,

                },
            });
        });
    }

    // Process monthly schedules
    if (timetable.monthly) {
        timetable.monthly.forEach((item) => {
            const week = {
                monday: { isActive: false },
                tuesday: { isActive: false },
                wednesday: { isActive: false },
                thursday: { isActive: false },
                friday: { isActive: false },
                saturday: { isActive: false },
                sunday: { isActive: false },
            };

            item.days.forEach((day) => {
                week[day.toLowerCase()] = {
                    isActive: true,
                };
            });

            schedule.push({
                id: idCounter++,
                data: {
                    period: "monthly",
                    globalStartTime: item.start,
                    globalEndTime: item.stop,
                    interval: item.quantifier.toLowerCase(),
                    week,

                },
            });
        });
    }
    return schedule;
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

// Transform UI state format to GraphQl timetable data
export const transformStateToTimetable = (schedule) => {
    const timetable = {
        daily: [],
        weekly: [],
        monthly: [],
    };

    schedule.forEach((entry) => {
        const { period, globalStartTime, globalEndTime, interval, week } = entry.data;

        if (period === "daily") {
            timetable.daily.push({
                start: globalStartTime,
                stop: globalEndTime,
            });
        } else if (period === "weekly") {
            const days = Object.keys(week)
                .filter((day) => week[day].isActive)
                .map((day) => day.charAt(0).toUpperCase() + day.slice(1));

            timetable.weekly.push({
                start: globalStartTime,
                stop: globalEndTime,
                days,

            });
        } else if (period === "monthly") {
            const days = Object.keys(week)
                .filter((day) => week[day].isActive)
                .map((day) => day.charAt(0).toUpperCase() + day.slice(1));

            timetable.monthly.push({
                start: globalStartTime,
                stop: globalEndTime,
                quantifier: interval && interval.charAt(0).toUpperCase() + interval.slice(1),
                days,
            });
        }
    });

    return timetable;
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

export const getSecondsFromTimeString = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

export const getTimeStringFromSeconds = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

export const checkDefaultCustomAnnouncement = (announcements) => {
    let list = announcements;
    let res = false;
    list.map((item) => {
        if (item.prefixList[0] === "default") {
            res = true;
        }
    });
    return res;
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

export const getAnnouncementsWithoutDefault = (announcements) => {
    return announcements
        .filter((item) => item.prefixList[0] !== "default")
        .map(({ __typename, ...rest }) => rest);
};
// -----------------------------------------------------------------------------------------------------------------------------------------------

export const getDefaultAnnouncements = (announcements) => {
    const defaultAnnouncement = announcements.find((item) => item.prefixList[0] === "default");
    if (defaultAnnouncement) {
        const { __typename, ...rest } = defaultAnnouncement;
        return rest;
    } else {
        return {
            prefixList: ["default"],
            start: "",
            stop: "",
        };
    }
};
// -----------------------------------------------------------------------------------------------------------------------------------------------
// Get the amount of conversations to record based on the selected recording type
export function getAmountOfConversationsToRecord(type, val1, val2, val3) {
    switch (type) {
        case "EveryXthConversation":
            return val1;
        case "PercentOfConversations":
            return val2;
        case "FirstXConversations":
            return val3;
        default:
            return 0;
    }
}
// -----------------------------------------------------------------------------------------------------------------------------------------------

/**
 * Compare two schedule objects for equality based on their type and relevant fields.
 * Returns true if they are the same.
 */
export function areSchedulesEqual(sch1, sch2) {

    let a = sch1?.data || sch1;
    let b = sch2?.data || sch2;
    if (!a || !b) return false;
    if (a.period !== b.period) return false;

    // Compare daily
    if (a.period === "daily") {
        return a.globalStartTime === b.globalStartTime &&
            a.globalEndTime === b.globalEndTime;
    }

    // Compare weekly
    if (a.period === "weekly") {
        const daysA = a.week || {};
        const daysB = b.week || {};
        const days = Object.keys(daysA);
        for (let day of days) {
            if ((daysA[day]?.isActive || false) !== (daysB[day]?.isActive || false)) {
                return false;
            }
        }
        return a.globalStartTime === b.globalStartTime &&
            a.globalEndTime === b.globalEndTime;
    }

    // Compare monthly
    if (a.period === "monthly") {
        const daysA = a.week || {};
        const daysB = b.week || {};
        const days = Object.keys(daysA);
        for (let day of days) {
            if ((daysA[day]?.isActive || false) !== (daysB[day]?.isActive || false)) {
                return false;
            }
        }
        return a.globalStartTime === b.globalStartTime &&
            a.globalEndTime === b.globalEndTime &&
            a.interval === b.interval;
    }

    return false;
}

export function doesProfileNameExist(list, name) {
    if (!Array.isArray(list) || !name) return false;
    return list.some(item => item.name?.trim().toLowerCase() === name.trim().toLowerCase());
}